import React from 'react';
import { Fade } from 'react-awesome-reveal';
import {
  FaShieldAlt, FaRobot, FaDatabase, FaRocket, FaChartLine, FaMicrosoft, FaGraduationCap, FaLock
} from 'react-icons/fa';
import Header from 'parts/Header';
import Footer from 'parts/Footer';
import Button from '../elements/Button';

const servicesDetails = [
  {
    icon: <FaShieldAlt />,
    title: "Cyber Security",
    description: "We bieden audits, penetratietesten, security awareness trainingen en voortdurende monitoring om jouw bedrijf tegen digitale bedreigingen te beschermen.",
    examples: "Voorbeeld: penetratietest, phishing simulatie, SOC-oplossingen."
  },
  {
    icon: <FaRobot />,
    title: "AI & LLM's",
    description: "Implementatie van AI-oplossingen zoals chatbots, intelligent documentbeheer, predictive analytics en generatieve AI voor efficiëntere bedrijfsprocessen.",
    examples: "Voorbeeld: ChatGPT-integratie, AI-assistenten, gepersonaliseerde aanbevelingen."
  },
  {
    icon: <FaDatabase />,
    title: "Data-analyse",
    description: "Analyse van bedrijfsdata om waardevolle inzichten te creëren voor betere besluitvorming en strategische planning.",
    examples: "Voorbeeld: klantsegmentatie, voorspellende analyses, dashboards en rapportage."
  },
  {
    icon: <FaRocket />,
    title: "Automatisering",
    description: "Ontwerp en uitvoering van automatisering om repetitieve taken te verminderen en de productiviteit te verhogen.",
    examples: "Voorbeeld: workflowautomatisering, RPA (Robotic Process Automation)."
  },
  {
    icon: <FaChartLine />,
    title: "SEO & Marketing",
    description: "Optimalisatie van jouw online aanwezigheid door gerichte SEO-strategieën en geautomatiseerde marketingcampagnes.",
    examples: "Voorbeeld: keywordanalyse, SEO-audits, geautomatiseerde social media campagnes."
  },
  {
    icon: <FaMicrosoft />,
    title: "Microsoft 365 & Copilot",
    description: "Maximaliseer productiviteit en samenwerking binnen jouw organisatie met geavanceerde Microsoft 365-oplossingen en AI-ondersteuning via Copilot.",
    examples: "Voorbeeld: Microsoft Teams-automatisering, Copilot-integraties in Office-apps."
  },
  {
    icon: <FaGraduationCap />,
    title: "Training & Studies",
    description: "Maatwerk trainingen en opleidingen gericht op actuele IT-thema's zoals cybersecurity, data-analyse en AI.",
    examples: "Voorbeeld: In-house opleidingen, online cursussen, gecertificeerde trainingen."
  },
  {
    icon: <FaLock />,
    title: "Privacy & Security",
    description: "Compliance advies en implementatie van privacybeleid volgens AVG/GDPR, ISO-certificeringen en andere beveiligingsstandaarden.",
    examples: "Voorbeeld: AVG-compliance audits, privacy impact assessments (PIA)."
  },
];

export default function GalacticServicesPage() {
  return (
    <div className="bg-gradient-to-r from-[#0a0a1d] to-[#14143a] min-h-screen text-white flex flex-col">
      <Header />

      {/* SERVICES HERO SECTION */}
      <section className="container mx-auto px-6 py-16 text-center">
        <Fade triggerOnce direction="up">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Onze Diensten
          </h1>
          <p className="text-xl md:text-2xl text-gray-200">
            Ontdek hoe Galactic Automation jouw organisatie ondersteunt met gespecialiseerde oplossingen.
          </p>
        </Fade>
      </section>

      {/* SERVICES DETAILS SECTION */}
      <section className="container mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {servicesDetails.map((service, idx) => (
          <Fade key={service.title} triggerOnce direction="up" delay={idx * 100}>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-md hover:bg-opacity-20 transition h-full flex flex-col">
              <div className="text-3xl mb-3 mx-auto text-indigo-400">{service.icon}</div>
              <h3 className="text-2xl font-bold mb-2 text-center">{service.title}</h3>
              <p className="text-gray-200 mb-4 flex-grow">{service.description}</p>
              <p className="italic text-sm text-gray-400">{service.examples}</p>
            </div>
          </Fade>
        ))}
      </section>

      {/* CALL TO ACTION SECTION */}
      <section className="bg-indigo-700 bg-opacity-20 py-16 px-6 text-center">
        <Fade triggerOnce direction="up">
          <h2 className="text-3xl font-bold mb-4">Klaar om te starten?</h2>
          <Button href="/discuss-project" type="link" className="bg-indigo-500 px-6 py-3 rounded-full font-bold hover:bg-indigo-600 transition duration-300">
            Neem Contact Op
          </Button>
        </Fade>
      </section>

      <Footer />
    </div>
  );
}
